export default __webpack_public_path__ + "static/media/2 User-1.b2e377e7.svg";